<template>
  <v-form ref="form_7">
    <v-container>
      <v-layout row class="px-4">
        <TermsConditions />
      </v-layout>
      <v-layout row wrap class="justify-center">
        <v-btn
          @click="setPreviousStep()"
          class="accent_light"
        >
          <v-icon class="reverse">arrow_right_alt</v-icon>
          Previous
        </v-btn>
        <v-btn
          @click="setNextStep()"
          :disabled="testCompleteStep(getFormIndexByPath('/summary')) === false"
          class="accent"
        >
          CONTINUE
          <v-icon>arrow_right_alt</v-icon>
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import store from "../../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import TermsConditions from "@/components/pages/TermsConditions.vue";

export default {
  name: "FormSummary",
  props: [],
  store: store,
  components: {TermsConditions},
  mixins: [BookingFormMixin, Shared],
  mounted() {
    const step = this.getStepNumberByPath("/booking/summary");
    if (store.state.active !== step) {
      store.commit("setActiveStep", step);
    }
		this.clearAllStudentSeniorSelections();
  }
};
</script>
